(ns common.status
  (:require
   [common.util :as cu]))

(def oppo-status-options
  [{:key   :oppo.status/ok
    :label "Active"}
   {:key   :oppo.status/passed
    :label "Passed"}
   {:key   :oppo.status/on-hold
    :label "On hold"}
   {:key   :oppo.status/portfolio
    :label "Portfolio"}])

(def fundraising-opportunity-status-options
  [{:key   :fundraising-opportunity.status/active
    :label "Active"}
   {:key   :fundraising-opportunity.status/lost
    :label "Lost"}
   {:key   :fundraising-opportunity.status/on-hold
    :label "On hold"}
   {:key   :fundraising-opportunity.status/won
    :label "Won"}])

(def sales-opportunity-status-options
  [{:key   :sales-opportunity.status/active
    :label "Active"}
   {:key   :sales-opportunity.status/lost
    :label "Lost"}
   {:key   :sales-opportunity.status/on-hold
    :label "On hold"}
   {:key   :sales-opportunity.status/won
    :label "Won"}])

(def exit-opportunity-status-options
  [{:key   :exit-opportunity.status/active
    :label "Active"}
   {:key   :exit-opportunity.status/on-hold
    :label "On hold"}
   {:key   :exit-opportunity.status/lost
    :label "Lost"}
   {:key   :exit-opportunity.status/won
    :label "Won"}])

(defn get-label
  [k]
  (or (->> oppo-status-options
           (cu/filter-by :key k)
           (first)
           :label)
      (->> fundraising-opportunity-status-options
           (cu/filter-by :key k)
           (first)
           :label)
      (->> sales-opportunity-status-options
           (cu/filter-by :key k)
           (first)
           :label)
      (->> exit-opportunity-status-options
           (cu/filter-by :key k)
           (first)
           :label)))

(defn get-status
  [entity]
  (or (:oppo/status entity)
      (:sales-opportunity/status entity)
      (:fundraising-opportunity/status entity)
      (:exit-opportunity/status entity)))

(defn active?
  [status]
  (or (= status :oppo.status/ok)
      (= status :sales-opportunity.status/active)
      (= status :fundraising-opportunity.status/active)
      (= status :exit-opportunity.status/active)))

(defn on-hold?
  [status]
  (or (= status :oppo.status/on-hold)
      (= status :sales-opportunity.status/on-hold)
      (= status :fundraising-opportunity.status/on-hold)
      (= status :exit-opportunity.status/on-hold)))

(defn portfolio?
  [status]
  (= status :oppo.status/portfolio))

(defn passed?
  [status]
  (= status :oppo.status/passed))

(defn won?
  [status]
  (or (= status :sales-opportunity.status/won)
      (= status :fundraising-opportunity.status/won)
      (= status :exit-opportunity.status/won)))

(defn lost?
  [status]
  (or (= status :sales-opportunity.status/lost)
      (= status :fundraising-opportunity.status/lost)
      (= status :exit-opportunity.status/lost)))
